import { Gondor } from "../Gondor";

const ACTIONS = {
  AFFILIATION: "/automations/affiliation",
  UPLOAD: "/automations/updateSheet",
};

export function affiliation(body: any) {
  return Gondor.API.post(ACTIONS.AFFILIATION, body);
}

export function uploadAffiliation(body: any) {
  return Gondor.API.post(ACTIONS.UPLOAD, body);
}
